<ng-container *ngIf="offerSet">

  <ng-container *ngIf="offerSet.enable_membership_goal">
    <label>
      {{ offerSet.membership_goal_current_value | number }} New Memberships

      <progress class="orange" [max]="offerSet.membership_goal" [value]="offerSet.membership_goal_current_value"></progress>
    </label>

    <p>
      {{ ratio() | percent }} of {{ offerSet.membership_goal | number }}
    </p>
  </ng-container>

  <ng-container *ngIf="!offerSet.enable_membership_goal">
    <p>This feature is not enabled</p>
  </ng-container>

</ng-container>
